export default [{ key: 'male' }, { key: 'female' }, { key: 'non-binary' }]

export const frontPageGenders = [
  { key: 'all' },
  { key: 'male' },
  { key: 'female' },
  { key: 'non-binary' },
]
